import React, { useContext } from 'react';
import { ModalContext, CustomFooter } from 'commons-ui';
import useHandler from '../../../useHandlers';
import { ACTION_IDS, BUTTON_LABELS } from '../../../constants';
import { IBankUpiAction, IBankUpiHandleParams } from '../model/bankUpiDetail.model';

export const makeBankAndUpiActionHandler = (action: IBankUpiAction, params: IBankUpiHandleParams) => {
	const { setForceUpdate, getUpiAndBankDetails, getBasicUserInfo } = params;
	const { setModalConfig } = useContext(ModalContext);
	const { onAgreeUnsetAccount, onDisAgreeUnsetAccount, onAgreeUnsetUpiId, onDisAgreeUnsetUpiId } = useHandler({
		setForceUpdate,
		getUpiAndBankDetails,
		getBasicUserInfo
	});

	switch (action.id) {
		case ACTION_IDS.UNSET_ACCOUNT_NUM:
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'Unset Bank Account Details',
					content: 'Are you sure you want to unset the bank account details for this user?',
					footer: (
						<CustomFooter
							agreeLabel={BUTTON_LABELS.AGREE}
							disagreeLabel={BUTTON_LABELS.DISAGREE}
							onAgreeClick={onAgreeUnsetAccount}
							onDisagreeClick={onDisAgreeUnsetAccount}
						/>
					)
				});
			};
		case ACTION_IDS.UNSET_UPI_ID:
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'Unset Upi Id',
					content: 'Are you sure you want to unset the upiId for this user?',
					footer: (
						<CustomFooter
							agreeLabel={BUTTON_LABELS.AGREE}
							disagreeLabel={BUTTON_LABELS.DISAGREE}
							onAgreeClick={onAgreeUnsetUpiId}
							onDisagreeClick={onDisAgreeUnsetUpiId}
						/>
					)
				});
			};
		default:
			return () => {};
	}
};

export default {
	makeBankAndUpiActionHandler
};
